import { render, staticRenderFns } from "./CorrectionEvent.vue?vue&type=template&id=c4a293bc"
import script from "./CorrectionEvent.vue?vue&type=script&lang=js"
export * from "./CorrectionEvent.vue?vue&type=script&lang=js"
import style0 from "./CorrectionEvent.vue?vue&type=style&index=0&id=c4a293bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports